import { createFileRoute } from '@tanstack/react-router';

import { MyActivitiesPage } from '@/modules/Activities/MyActivities/MyActivitiesPage';

export const Route = createFileRoute('/app/activities/')({
  component: MyActivitiesPage,
});
